import { render } from "./DfcPersonalinfo.vue?vue&type=template&id=28b6947a&scoped=true"
import script from "./DfcPersonalinfo.vue?vue&type=script&lang=js"
export * from "./DfcPersonalinfo.vue?vue&type=script&lang=js"

import "./DfcPersonalinfo.vue?vue&type=style&index=0&id=28b6947a&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b6947a"]])

export default __exports__